<div class="closeButton" @click="$emit('onClick')" :style="`width: ${size}px; height: ${size}px`"><ui-svg-icon name="close" :size="size"></ui-svg-icon></div>